import React from 'react';
import clsx from 'clsx';
import styles from './Spinner.module.scss';
export const Spinner = ({ className = '' })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.spinner, className)
    });
